import { render, staticRenderFns } from "./PDFcreate_B.vue?vue&type=template&id=385cb05b&scoped=true&"
import script from "./PDFcreate_B.vue?vue&type=script&lang=js&"
export * from "./PDFcreate_B.vue?vue&type=script&lang=js&"
import style0 from "./PDFcreate_B.vue?vue&type=style&index=0&id=385cb05b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385cb05b",
  null
  
)

export default component.exports